import { AmostraComercial } from '@models/amostra-comercial.model';
import { ViewAmostraAtual } from '@models/views/view-amostra-atual.model';
import axios from 'axios';
import { ListaAcompanhamentoAmostraComercialQueryDto } from '@/../../back/src/amostras-comerciais/dto/lista-acompanhamento-amostra-comercial-query.dto';
import { Arquivo } from '@models/arquivo.model';

const listaAcompanhamento = async (
  queryDto: ListaAcompanhamentoAmostraComercialQueryDto,
): Promise<{
  count: number;
  rows: ViewAmostraAtual[];
}> => {
  const res = await axios.get<{ count: number; rows: ViewAmostraAtual[] }>(
    '/amostras_comerciais/acompanhamento',
    {
      params: queryDto,
    },
  );
  return res.data;
};
const cria = async (formData: FormData): Promise<AmostraComercial> => {
  const res = await axios.post<AmostraComercial>(
    '/amostras_comerciais',
    formData,
  );
  return res.data;
};

const alteraFotoAmostra = async (
  amostraId: number,
  formData: FormData,
): Promise<Arquivo> => {
  const res = await axios.patch<Arquivo>(
    `/amostras_comerciais/${amostraId}/altera_foto_amostra`,
    formData,
  );
  return res.data;
};

export default {
  listaAcompanhamento,
  cria,
  alteraFotoAmostra,
};
